
import { AiChatAssistantPanel } from "app/components/ai-chat-assistant-panel/ai-chat-assistant-panel";
import * as React from "react";

export function WithAiChatAssistantPanel<P>() {
  return (
    WrappedComponent:
      | React.ComponentClass<P>
      | React.FC<React.PropsWithChildren<P>>
  ) => {
    return (props: P & { aiChat?: boolean; }) => {
      const { aiChat } = props;

      if (!aiChat) {
        return <WrappedComponent {...props} />;
      }

      return (
        <AiChatAssistantPanel  {...props}>
          <WrappedComponent
            {...props}
          />
        </AiChatAssistantPanel >
      );
    };
  };
}
